export interface FAQ {
  question: string;
  answer: string;
}

export const faqs: FAQ[] = [
  {
    question: 'Is this therapy?',
    answer:
      'No. EmpathEase is an educational platform that teaches communication skills based on Nonviolent Communication (NVC). While many therapists recommend NVC, our app is not a replacement for professional therapy. Think of it as a gym for your communication muscles — we teach skills, not diagnose or treat.',
  },
  {
    question: 'What if only one of us wants to try it?',
    answer:
      "That's actually how most people start! NVC skills work even when only one person uses them. When you change how you listen and express yourself, the entire dynamic shifts. Many of our users report significant improvements even when their partner isn't using the app.",
  },
  {
    question: "Will it actually stick, or is this another thing I'll quit after a week?",
    answer:
      'We designed EmpathEase specifically for busy people. Lessons are 5-10 minutes, and the gamified format keeps you coming back. Our AI tutor adapts to your pace, and the empathy practice sessions give you real accountability. Most users stay active for 3+ months.',
  },
  {
    question: "I'm not in a couple. Is this still for me?",
    answer:
      'Absolutely! NVC skills improve every relationship — with family, friends, coworkers, and even yourself. Many of our users are parents, managers, teachers, or simply people who want to communicate more authentically.',
  },
  {
    question: 'How much time does this take?',
    answer:
      'Just 10 minutes a day is enough to make real progress. Each lesson is self-contained, so you can learn at your own pace. Premium members also get access to an AI tutor, Echo Arena, live empathy sessions, and 2,500 monthly credits.',
  },
  {
    question: 'Can I cancel anytime?',
    answer:
      'Yes, absolutely. You can cancel your subscription at any time with no penalties or hidden fees. Your free-tier access continues even after cancellation, so you never lose your progress.',
  },
  {
    question: 'Is my data private?',
    answer:
      'Yes. We take privacy seriously. Your conversations with the AI tutor and in empathy sessions are encrypted. We never sell your data. You can export or delete your data at any time from your privacy dashboard. Read our full privacy policy for details.',
  },
  {
    question: 'Who facilitates the live empathy sessions?',
    answer:
      'Live empathy sessions connect you with fellow community members who have completed the introductory learning path. These are peer practice sessions — a chance to give and receive empathy with others on their own NVC journey. After a session, you can optionally tip your empathy partner to show appreciation.',
  },
];
